import "packs/restaurant/reservations";
import "packs/restaurant/special_days";
import "packs/restaurant/schedule";
import "packs/restaurant/test_email";
import "packs/restaurant/test_sms";
import "packs/restaurant/test_phone";
import "packs/restaurant/test_fax";
import "packs/restaurant/refresh_at";
import "packs/restaurant/schedule_builder";

document.addEventListener("turbolinks:load", function () {
  function collapseColumns(tableBody) {
    document.getElementById("tableBody").classList.toggle("collapsed");
    document.querySelector(".hamburger-icon").classList.toggle("collapsed");

    $.ajax({
      dataType: "json",
      url: `/restaurant/reservations/collapsed_state`,
      success: function (data) {
        console.log(data);
      },
      error: function (data) {
        console.log(data);
      },
    });
  }

  var colTrigger = document.getElementById("collapseTrigger");
  if (colTrigger != null) {
    colTrigger.addEventListener("click", collapseColumns);
  }
});
